<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Zusatzflächen</h2>
      <p class="step-text">
        Geben Sie hier die Flächen der Ausstattungsdetails an.
      </p>
    </div>
    <div class="step-body">
      <div class="row gx-5 justify-content-center">
        <div
          class="col-md-6"
          v-if="isSet(readonly.flagBalkon.value)"
        >
          <InputRange
            id="ws7b_s1"
            min="0"
            max="240"
            v-model="fields.whgBalkonM2.value"
            :defaultValue="fields.whgBalkonM2.default"
            label="Gesamtfläche Balkon / Loggia"
            unit="m²"
            :state="fields.whgBalkonM2.state"
            @update:modelValue="validate('whgBalkonM2')"
          />
        </div>
        <!-- <div
          class="col-md-4"
          v-if="isSet(readonly.flagBalkon.value)"
        >
          <InputRange
            id="ws7b_s2"
            min="0"
            max="240"
            v-model="fields.whgWintergartenM2.value"
            :defaultValue="fields.whgWintergartenM2.default"
            label="Größe Wintergarten"
            unit="m²"
            :state="fields.whgWintergartenM2.state"
            @update:modelValue="validate('whgWintergartenM2')"
          />
        </div> -->
        <div
          class="col-md-6"
          v-if="isSet(readonly.flagTerrasse.value)"
        >
          <InputRange
            id="ws7b_s3"
            min="0"
            max="240"
            v-model="fields.TerrasseM2.value"
            :defaultValue="fields.TerrasseM2.default"
            label="Größe Terrasse"
            unit="m²"
            :state="fields.TerrasseM2.state"
            @update:modelValue="validate('TerrasseM2')"
          />
        </div>
        <div
          class="col-md-6"
          v-if="isSet(readonly.flagGarage.value)"
        >
          <NumberField
            v-model="fields.whgGaragenStk.value"
            :defaultValue="fields.whgGaragenStk.default"
            label="Anzahl Garagenplätze"
            :state="fields.whgGaragenStk.state"
            @update:modelValue="validate('whgGaragenStk')"
          />
        </div>
        <div
          class="col-md-6"
          v-if="isSet(readonly.flagGarten.value)"
        >
          <InputRange
            id="ws7b_s4"
            min="0"
            max="4000"
            v-model="fields.whgGartenM2.value"
            :defaultValue="fields.whgGartenM2.default"
            label="Größe Garten"
            unit="m²"
            :state="fields.whgGartenM2.state"
            @update:modelValue="validate('whgGartenM2')"
          />
        </div>
        <!-- <div
          class="col-md-6"
          v-if="isSet(readonly.flagKeller.value)"
        >
          <InputRange
            id="ws7b_s5"
            min="1"
            max="500"
            v-model="fields.whgKellerM2.value"
            :defaultValue="fields.whgKellerM2.default"
            label="Größe Keller"
            unit="m²"
            :state="fields.whgKellerM2.state"
            @update:modelValue="validate('whgKellerM2')"
          />
        </div> -->
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputRange from "@/components/shared/InputRange.vue";
import NumberField from "@/components/shared/NumberField.vue";
import {
  getFromStorage,
  saveToStorage,
  isSet,
  checkValidFields,
  checkInvalidFields,
  containsInvalidFields,
  validateField,
  setDefaults,
} from "@/utils.js";
export default {
  name: "wohnung-step-8b",
  components: {
    InputRange,
    NumberField,
  },
  data() {
    return {
      fields: {
        whgBalkonM2: {
          default: "0",
          validators: ["required", "min:0"],
        },
        // whgWintergartenM2: {
        //   default: "0",
        //   validators: ["required", "min:0"],
        // },
        TerrasseM2: {
          default: "0",
          validators: ["required", "min:0"],
        },
        whgGaragenStk: {
          default: "1",
          validators: ["required", "min:1"],
        },
        whgGartenM2: {
          default: "50",
          validators: ["required", "min:0"],
        },
        // whgKellerM2: {
        //   default: "50",
        //   validators: ["required", "min:1"],
        // },
      },
      readonly: {
        flagBalkon: { value: null },
        flagTerrasse: { value: null },
        flagGarage: { value: null },
        flagGarten: { value: null },
        // flagKeller: { value: null },
      },
    };
  },
  methods: {
    isSet: isSet,
    goBack() {
      setDefaults(this.fields);
      saveToStorage(this.fields);
      this.$router.push("/reihenhaus-step-8a");
    },
    goNext() {
      setDefaults(this.fields);
      checkInvalidFields(this.fields);
      if (!containsInvalidFields(this.fields)) {
        this.removeOtherValues();
        saveToStorage(this.fields);
        this.$router.push("/reihenhaus-step-9");
      }
    },
    validate(name) {
      const field = this.fields[name];
      field.state = validateField(field.value, field.validators);
    },
    //remove other values (f.e. whgKellerM2 if flagKeller is not set)
    removeOtherValues(){
      this.fields.whgBalkonM2.value = isSet(this.readonly.flagBalkon.value) ? this.fields.whgBalkonM2.value : null;
      // this.fields.whgWintergartenM2.value = isSet(this.readonly.flagBalkon.value) ? this.fields.whgWintergartenM2.value : null;
      this.fields.TerrasseM2.value = isSet(this.readonly.flagTerrasse.value) ? this.fields.TerrasseM2.value : null;
      this.fields.whgGaragenStk.value = isSet(this.readonly.flagGarage.value) ? this.fields.whgGaragenStk.value : "0";
      this.fields.whgGartenM2.value = isSet(this.readonly.flagGarten.value) ? this.fields.whgGartenM2.value : null;
      // this.fields.whgKellerM2.value = isSet(this.readonly.flagKeller.value) ? this.fields.whgKellerM2.value : null;
    },
  },
  mounted() {
    this.$emit("setStep", "reihenhaus", 10);
    getFromStorage(this.readonly);
    getFromStorage(this.fields);
    checkValidFields(this.fields);
  },
};
</script>
<style scoped>
.step-body {
  margin-bottom: 55px;
}
.step-body .row {
  row-gap: 55px;
}
@media only screen and (max-width: 768px) {
  .step-body {
    margin-bottom: 55px;
  }
}
</style>
